module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.ttf?cf3b376d9576e4a9b0ba7ee4cdb3ec47";